import { Colors } from '@sigma-frontend-libs/commons'
import { upgradeArray } from '@sigma-legacy-libs/essentials/lib/utils'
import { TaskFrequency, TaskStates, TaskTypes } from '@sigmasms/shared-types'

import { datePresets, icons } from '@/utils'

export const countsTypes = upgradeArray([ 'completed', 'errored', 'remaining', 'total' ])

export const countsColors = {
  completed: Colors.success,
  errored: Colors.error,
  remaining: Colors.primary,
  total: Colors.black
}

export const typeColors = {
  [TaskTypes['payments:recurrent']]: Colors.info,
  [TaskTypes['billings:operations']]: Colors.success
}
export const typeIcons = {
  [TaskTypes['payments:recurrent']]: 'repeat',
  [TaskTypes['billings:operations']]: 'account_balance'
}

export const tasksStates = {
  [TaskStates.completed]: {
    icon: icons.check_circle_outline,
    color: Colors.success
  },
  [TaskStates.paused]: {
    icon: icons.pause_circle_outline,
    color: Colors.warning
  },
  [TaskStates.running]: {
    icon: icons.keyboard_double_arrow_right,
    color: Colors.primary
  },
  [TaskStates.scheduled]: {
    icon: icons.access_time,
    color: Colors.epic
  },
  [TaskStates.failed]: {
    icon: icons.error_outline,
    color: Colors.error
  },
  [TaskStates.stopped]: {
    icon: icons.stop_circle,
    color: Colors.error
  }
}

export const tasksFilter = {
  id: undefined,
  ListId: undefined,
  OwnerId: undefined,
  CreatorId: undefined,
  state: undefined,
  type: undefined,
  isActive: true,
  startsAt: {
    $gt: undefined,
    $lt: undefined
  },
  createdAt: {
    $gt: undefined,
    $lt: undefined
  },
  createdAtPreset: datePresets.today,
  $scope: [ 'full' ]
}

// NOTE: https://sigmasms.slack.com/archives/C073ZQ5H5UY/p1773936189278199?thread_ts=1773919071.271979&cid=C073ZQ5H5UY
export const billingsOperationsFrequencies = [
  TaskFrequency.once,
  TaskFrequency.daily,
  TaskFrequency.monthly
]
